import {fork, put, select, take} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as qualityManagementActionTypes from '../qualityManagementFeedbackActionTypes';

/**
 * Search Quality Management Feedbacks
 */
const searchQualityManagementFeedbacks = function* searchQualityManagementFeedbacks({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');
    const {searchQueryParams} = payload;

    yield put({
        type: qualityManagementActionTypes.SET_QM_FEEDBACKS_SEARCH_PERSISTENCE_STATE,
        payload: {persistenceState: persistenceStates.PENDING},
    });

    yield fork(
        fetchRequest,
        qualityManagementActionTypes.SEARCH_QUALITY_MANAGEMENT_FEEDBACKS_REQUEST,
        partnerManagementService.getQualityManagementFeedbacks,
        {
            searchQueryParams,
        },
    );

    const responseAction = yield take([
        qualityManagementActionTypes.SEARCH_QUALITY_MANAGEMENT_FEEDBACKS_REQUEST_SUCCEEDED,
        qualityManagementActionTypes.SEARCH_QUALITY_MANAGEMENT_FEEDBACKS_REQUEST_FAILED,
    ]);

    if (responseAction.error) {
        yield put({
            type: qualityManagementActionTypes.STORE_QUALITY_MANAGEMENT_FEEDBACKS_SEARCH_RESULTS,
            payload: {
                qualityManagementFeedbacksSearchResults: [],
                qualityManagementFeedbacksSearchCount: 0,
                positiveQMFeedbacksCount: 0,
                negativeQMFeedbacksCount: 0,
            },
        });
        yield put({
            type: qualityManagementActionTypes.SET_QM_FEEDBACKS_SEARCH_PERSISTENCE_STATE,
            payload: {persistenceState: persistenceStates.FAILED},
        });

        return;
    }

    const {response} = responseAction.payload;

    const {
        acePartnerQualityManagementFeedbackDTOs: qualityManagementFeedbacksSearchResults,
        totalCount: qualityManagementFeedbacksSearchCount,
        countPositive: positiveQMFeedbacksCount,
        countNegative: negativeQMFeedbacksCount,
    } = response;

    yield put({
        type: qualityManagementActionTypes.STORE_QUALITY_MANAGEMENT_FEEDBACKS_SEARCH_RESULTS,
        payload: {
            qualityManagementFeedbacksSearchResults,
            qualityManagementFeedbacksSearchCount,
            positiveQMFeedbacksCount,
            negativeQMFeedbacksCount,
        },
    });

    yield put({
        type: qualityManagementActionTypes.STORE_QUALITY_MANAGEMENT_FEEDBACKS,
        payload: {qualityManagementFeedbackDTOs: qualityManagementFeedbacksSearchResults},
    });

    yield put({
        type: qualityManagementActionTypes.SET_QM_FEEDBACKS_SEARCH_PERSISTENCE_STATE,
        payload: {persistenceState: persistenceStates.READY},
    });
};

export default searchQualityManagementFeedbacks;
